
<div class="btn-group-toggle d-block text-uppercase p-3 text-center justify-content-around d-flex" data-toggle="buttons">
    <label *ngFor="let option of options" class="btn btn-secondary px-4"
        [ngClass]="{'disabled': disabled || option.disabled, 'active': option.value === value }"
        (click)="handleClick(option.value)">{{option.text}}</label>
</div>